import { render, staticRenderFns } from "./ProjectNoCard.vue?vue&type=template&id=201babb8&"
import script from "./ProjectNoCard.vue?vue&type=script&lang=js&"
export * from "./ProjectNoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports